import React from 'react';
import { Button } from './button';
import { ChevronDown } from 'lucide-react';

export const HeroSection = ({ onApplyClick, onScrollToForm }) => {
  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center bg-cream overflow-hidden pt-24">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-cream via-white to-brand-silver-light"></div>
      
      {/* Main content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Full-width Landscape GIF */}
          <div className="mb-8 w-full">
            <img 
              src="https://customer-assets.emergentagent.com/job_hair-opportunity/artifacts/koak0hwa_Start%20hair%20extensions%20Business%20.gif"
              alt="Start Hair Extensions Business - Need A Hair Makeover Franchise"
              className="w-full h-auto rounded-2xl shadow-2xl border-4 border-accent-primary/20 object-contain"
            />
          </div>
          
          <h1 className="hero-title text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-dark leading-tight">
            Start Your Own
            <span className="block text-accent-primary">Hair Extensions and Hairloss Specialist Salon</span>
            <span className="block">Franchise Opportunity</span>
          </h1>
          
          <p className="hero-subtitle text-xl md:text-2xl text-subtle mb-12 max-w-3xl mx-auto leading-relaxed">
            Join our award-winning salon franchise with full support, training, and growth opportunities across the UK.
            Specialists in hair extensions, hair loss treatments, and bespoke hair solutions.
          </p>
          
          {/* YouTube Video */}
          <div className="video-container mb-12 max-w-4xl mx-auto">
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl border-4 border-accent-primary/20">
              <iframe
                src="https://www.youtube.com/embed/OXkO6HbZML4"
                title="Need A Hair Makeover Franchise Opportunity"
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="mt-4 text-subtle font-medium">Watch our franchise opportunity overview</p>
          </div>
          
          <Button 
            onClick={() => {
              // Add UTM tracking for AI referrals
              const url = new URL(window.location);
              if (url.searchParams.get('utm_source') === 'chatgpt.com') {
                // Track AI referral
                console.log('AI referral detected');
              }
              onScrollToForm();
            }}
            size="lg"
            className="bg-white border-2 border-accent-primary text-accent-primary hover:bg-accent-primary hover:text-white text-lg px-12 py-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 font-semibold"
          >
            Apply Now for Your Franchise
          </Button>
          
          {/* Contact Info & Additional Links */}
          <div className="mt-8 space-y-4">
            <div className="text-sm text-subtle">
              <p>📞 <a href="tel:+442030514338" className="hover:text-accent-primary transition-colors">+44 20 3051 4338</a> | 📧 <a href="mailto:needahairmakeover@gmail.com" className="hover:text-accent-primary transition-colors">needahairmakeover@gmail.com</a></p>
            </div>
            
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <a 
                href="https://www.needahairmakeover.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-accent-primary px-4 py-2 rounded-full border-2 border-accent-primary hover:bg-accent-primary hover:text-white transition-all duration-300 font-medium"
              >
                📅 Book Appointment
              </a>
              <a 
                href="https://www.needahairmakeover.blog" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-accent-primary px-4 py-2 rounded-full border-2 border-accent-primary hover:bg-accent-primary hover:text-white transition-all duration-300 font-medium"
              >
                📖 Follow Our Blog
              </a>
            </div>
            
            <div className="text-xs text-subtle-light">
              <p>Follow us: @needahairmakeover (Instagram) | @needa_makeover (X) | /needahairmakeover2 (Facebook)</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-8 h-8 text-accent-primary" />
      </div>
    </section>
  );
};